import { combineReducers } from '@reduxjs/toolkit';

import activityAttributesReducer from './activityAttributes';
import columnConfigReducer from './columnConfig';
import exportActivitiesReducer from './exportActivities';
import importActivityReducer from './importActivity';
import manageActivitiesReducer from './manageActivities';
import secondaryFilterReducer from './secondaryFilter';

export const activitiesReducers = combineReducers({
  manageActivities: manageActivitiesReducer,
  secondaryFilter: secondaryFilterReducer,
  columnConfig: columnConfigReducer,
  exportActivities: exportActivitiesReducer,
  importActivity: importActivityReducer,
  attributes: activityAttributesReducer,
});
